import { render } from "./CreateDataStream.vue?vue&type=template&id=0e2dc052&scoped=true"
import script from "./CreateDataStream.vue?vue&type=script&lang=js"
export * from "./CreateDataStream.vue?vue&type=script&lang=js"

import "./CreateDataStream.vue?vue&type=style&index=0&id=0e2dc052&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2dc052"]])

export default __exports__